import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=62348b28&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=js&"
export * from "./MyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=62348b28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62348b28",
  null
  
)

export default component.exports